<section class="contact-area contact-page-area">
    <img class="w-100" src="https://www.netlabindia.com/wp-content/uploads/2018/06/contact-us-banner.jpg" alt="">
    <div class="container">
        <div class="row contact-page-wrapper">
            <div class="col-xl-9">
                <div class="contact-form-wrap" data-aos="fade-right">
                    <div class="contact-form-title">
                        <h2 class="title">We Are Here! <br>Please Send A Quest</h2>
                    </div>
                    <!--== Start Contact Form ==-->
                    <div class="contact-form">
                    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
                        <div class="row row-gutter-20">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input class="form-control" type="text" formControlName="name" placeholder="Name *">
                                    <div *ngIf="contactForm.get('name')?.invalid && contactForm.get('name')?.touched"
                                        style="color: #F56061;">
                                        Name is required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input class="form-control" type="email" formControlName="email" placeholder="Email *">
                                    <div *ngIf="contactForm.get('email')?.invalid && contactForm.get('email')?.touched"
                                        style="color: #F56061;">
                                        Please enter a valid email address.
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <input class="form-control" type="text" formControlName="subject" placeholder="Subject (Optional)">
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <input class="form-control" type="text" formControlName="mobile" placeholder="Mobile No">
                                    <div *ngIf="contactForm.get('mobile')?.invalid && contactForm.get('mobile')?.touched"
                                        style="color: #F56061;">
                                        Please enter a valid mobile number.
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group mb--0">
                                    <textarea class="form-control" formControlName="message" placeholder="Message"></textarea>
                                    <div *ngIf="contactForm.get('message')?.invalid && contactForm.get('message')?.touched"
                                        style="color: #F56061;">
                                        Message is required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group mb--0">
                                    <button class="btn-theme" type="submit" [disabled]="contactForm.invalid">Send Message</button>
                                </div>
                            </div>
                        </div>
                    </form>
                    </div>
                    <!--== End Contact Form ==-->

                    <!--== Message Notification ==-->
                    <div class="form-message"></div>
                 
                </div>
            </div>
            <div class="col-xl-3">
                <div class="contact-info-wrap">
                    <div class="contact-info">
                        <div class="row">
                            <div class="col-lg-4 col-xl-12">
                                <div class="info-item" data-aos="fade-left">
                                    <div class="icon">
                                        <img src="assets/img/icons/c1.webp" width="69" height="65" alt="Image-HasTech">
                                    </div>
                                    <div class="info">
                                        <h5 class="title">Address</h5>
                                        <p>Your address goes here. 123 Your Location</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-xl-12">
                                <div class="info-item" data-aos="fade-left" data-aos-delay="60">
                                    <div class="icon">
                                        <img src="assets/img/icons/c2.webp" width="65" height="65" alt="Image-HasTech">
                                    </div>
                                    <div class="info">
                                        <h5 class="title">Phone No</h5>
                                        <p>
                                            <a href="tel://+00123456789">+00123456789</a><br>
                                            <a href="tel://+00123456789">+00123456789</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-xl-12">
                                <div class="info-item" data-aos="fade-left" data-aos-delay="120">
                                    <div class="icon">
                                        <img src="assets/img/icons/c3.webp" width="65" height="65" alt="Image-HasTech">
                                    </div>
                                    <div class="info">
                                        <h5 class="title">Email / Web</h5>
                                        <p>
                                            <a href="mailto://www.example.com">www.example.com</a>
                                            <a href="mailto://www.example.com">www.DNJ.com</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<a target="_blank" href="https://api.whatsapp.com/send/?phone=9001783675&text&type=phone_number&app_absent=0">
    <img class="whats-app" src="https://media.tenor.com/rZPzTbfYtC4AAAAM/whats-app.gif" alt="" />
</a>